import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import CommonTable from "../../components/common/CommonTable";
import CommonFilter from "../../components/common/CommonFilter";
import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import TableConfig from "../../components/skillInfo/skillInfoListTableContent";
import { downloadWithURL } from "../../helper/ExportHelper";
import { getDataRequestPromise } from "../../helper/AxiosHelper";

export default function Component() {
  const [textFilters, setTextFilters] = useState([]);
  const [typeFilter, setTypeFilter] = useState("");
  const [isExporting, setIsExporting] = useState(false);
  const navigate = useNavigate();

  const filterQuery = useMemo(() => {
    const filters = [...textFilters];
    if (typeFilter) {
      filters.push({ field: "type", value: typeFilter, op: "eq" });
    }
    return filters;
  }, [textFilters, typeFilter]);

  const exportCsv = async () => {
    setIsExporting(true);
    const query = {
      filters: filterQuery,
      page: 1,
      page_size: -1,
      sort: "name_zh.asc",
    };
    const url = `/skillInfo/export?query=${encodeURIComponent(JSON.stringify(query))}&format=csv`;
    try {
      const body = await getDataRequestPromise(url);
      const result = body?.result || body;
      if (!result?.export_url) {
        toast.error("匯出失敗");
        return;
      }
      downloadWithURL(result.export_url, result.export_filename);
    } catch (error) {
      toast.error("匯出失敗");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Container maxWidth={"lg"}>
      <CommonBreadcrumb />
      <Paper sx={{ px: 3, pb: 3, mt: 6 }} elevation={3}>
        <Grid container rowSpacing={3} columnSpacing={2}>
          <Grid item xs={12}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              flexWrap="wrap"
              gap={2}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <CommonFilter
                  filterConfig={TableConfig.filterConfig}
                  emitQueryFn={setTextFilters}
                />
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <InputLabel id="skill-type-filter">類型</InputLabel>
                  <Select
                    labelId="skill-type-filter"
                    label="類型"
                    value={typeFilter}
                    onChange={(event) => setTypeFilter(event.target.value)}
                  >
                    <MenuItem value="">全部</MenuItem>
                    <MenuItem value="normal">一般</MenuItem>
                    <MenuItem value="fit_exam">體能測試</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
              <Box>
                <Button
                  size="small"
                  variant="contained"
                  endIcon={<AddIcon />}
                  onClick={() => navigate("/skill_info/create")}
                >
                  新增技能
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="secondary"
                  endIcon={<FileDownloadIcon />}
                  onClick={exportCsv}
                  disabled={isExporting}
                  sx={{ ml: 2 }}
                >
                  匯出 CSV
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="secondary"
                  endIcon={<FileUploadIcon />}
                  onClick={() => navigate("/skill_info/import")}
                  sx={{ ml: 2 }}
                >
                  匯入 CSV
                </Button>
              </Box>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <CommonTable
              filterQuery={filterQuery}
              tableConfig={TableConfig}
              options={{ pageSize: 20 }}
            />
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
